const styles = {
    blue:{
        color: 'rgb(33,77,142)',
        paddingRight: "0"
    },
    red: {
        color: "rgb(220,38,72)",
        paddingLeft:"0"
    },
}
export default styles;
